const messages = {
  'ar': require('./ar.json'),
  'bs': require('./bs.json'),
  'cs': require('./cs.json'),
  'de': require('./de.json'),
  'en': require('./en.json'),
  'fr': require('./fr.json'),
  'id': require('./id.json'),
  'it': require('./it.json'),
  'ja': require('./ja.json'),
  'ko': require('./ko.json'),
  'ru': require('./ru.json'),
  'sr': require('./sr.json'),
  'th': require('./th.json'),
  'tr': require('./tr.json'),
  'zh-s': require('./zh-s.json'),
  'zh-t': require('./zh-t.json'),
};

export default messages;